module.exports = __webpack_public_path__ + "static/media/7.a7b6e3b5.png";